export interface AspectRatioOption {
    id: string;
    name: string;
}

export const ASPECT_RATIO_OPTIONS: AspectRatioOption[] = [
    { id: "16x9", name: "16x9" },
    { id: "9x16", name: "9x16" },
    { id: "1x1", name: "1x1" },
    { id: "4x5", name: "4x5" },
    { id: "2x3", name: "2x3" },
];
